import React, { useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import './ChatToast.css';

export default function ChatToast({ toast, onDismiss, onClick }) {
  useEffect(() => {
    if (!toast) return undefined;
    const timeoutId = setTimeout(() => onDismiss?.(), 4000);
    return () => clearTimeout(timeoutId);
  }, [toast, onDismiss]);

  if (!toast) return null;

  return (
    <div className="chat-toast" onClick={onClick} role="button" tabIndex={0}>
      <div className="chat-toast__icon">
        <MessageCircle size={18} />
      </div>
      <div className="chat-toast__body">
        <div className="chat-toast__name">{toast.studentName}</div>
        <div className="chat-toast__message">{toast.message}</div>
      </div>
    </div>
  );
}
